export class AuthMapper {
  static mapToLoginRequestJson (data) {
    console.log('login AuthMapper', data);
    const request = {
      'email': data.email,
      'password': data.password,
    }
    return request;
  }
  static mapToToken (response) {
    const token = {
      accessToken: response.token,
      refreshToken: response.token,
    }
    return token;
  }
  static mapToRegisterRequestJson (data) {
    const date = new Date(`${data.dob}T00:00:00Z`)
    console.log('to iso date = ', date)
    const request = {
      email: data.email,
      name: data.name,
      password: data.password,
      dob: date,
      gender: data.gender,
      phone: data.phone,
    }
    return request;
  }
}
